import React from "react";
import TextWImageSection from "@/library/sections/texts/TextWImageSection";
import { storyblokEditable } from "@storyblok/react";

export default function TextWImageSectionBlock({ blok }) {
  return (
    <div {...storyblokEditable(blok)}>
      <TextWImageSection
        blok={blok}
        title={blok.title}
        titleAs={blok.titleAs}
        titleColor={blok.titleColor}
        subTitle={blok.subTitle}
        subTitleColor={blok.subTitleColor}
        backgroundColor={blok.backgroundColor}
        contentBlocks={blok.contentBlocks || []}
      />
    </div>
  );
}
